import administrators from './administrators.json';

export default {
  administrators,
};
